import React from "react"
import UnifiedDatePicker from "../../../components/compounds/UnifiedDatePicker.compound"

export function VacationDaysDatePicker({
  label,
  dateRange,
  setDateRange,
  period,
  datePickerProps,
  className = "",
}) {
  return (
    <div className={`vacation-days-date-picker ${className}`}>
      <label className="vacation-days-date-picker__label">{label}</label>
      <UnifiedDatePicker
        label={label}
        hasSingleWeek={false}
        hasSingleMonth={false}
        hasDayPeriod={false}
        hidePeriodSelector
        hideChevron
        dateRange={dateRange}
        setDateRange={setDateRange}
        period={period}
        datePickerProps={datePickerProps}
      />
    </div>
  )
}
